<template>
    <list-page icone="mdi-account-cash" titulo="Doador" @novo="Novo()" @atualizar="Atualizar()">
        <template v-slot:corpo>

          <v-expansion-panels focusable>
            <v-expansion-panel>
            <v-expansion-panel-header>Filtros</v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-row>
                  <v-col cols="12" md="1">
                    <v-text-field v-model="filter.codigo" label="Código" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field v-model="filter.cpfCnpj" label="CPF/CNPJ" v-mask="mskCpfCnpj" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="filter.nome" label="Nome" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select v-model="filter.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.cpfCnpj }}</td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.telefone }}</td>
                    <td>{{ item.celular }}</td>
                    <td>{{ item.email }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-doador v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()"/>

        </template>
    </list-page>
</template>
<script>
import DoadorService from '@/core/services/doacao/DoadorService';
import Doador from '@/core/domain/doacao/Doador';
import ListPage from "@/components/shared/ListPage";
import { SituacaoEnumService } from '../../../core/services/geral';

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false  },
        { text: '#', value: 'id', type:'number' },
        { text: 'CPF/CNPJ', value: 'cpfCnpj' },
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Celular', value: 'celular' },
        { text: 'E-mail', value: 'email' }
      ],
      situacoes: [],
      filter: {
        cpfCnpj: '',
        codigo: null,
        nome: '',
        situacao: '',
      },
      primeiraCarga: true,
      mskCpfCnpj: process.env.VUE_APP_MSK_CPF,
      mskCnpj: process.env.VUE_APP_MSK_CNPJ,
      maskCpf: process.env.VUE_APP_MSK_CPF,      
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      },
      "filter.cpfCnpj": function(val){
        if(val.length > 14){
          this.mskCpfCnpj = this.mskCnpj;
        }
        else{
          this.mskCpfCnpj = this.maskCpf;        
        }

      }
    },
    created() {
      this.service = new DoadorService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Doador());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Contatos, Indicador, Projeto")
          .then(
            res =>{
              this.EditarCadastro(new Doador(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      },
      Atualizar(){
        let paramTemp = '';

        if (this.filter.nome){
          paramTemp += `Contains(nome, '${this.filter.nome}')`;
        }

        if (this.filter.cpfCnpj){
          if (paramTemp) { paramTemp += ' and '; }
          paramTemp += `Contains(cpfCnpj, '${this.filter.cpfCnpj}')`;
        }

        if (this.filter.situacao){
          if (paramTemp) { paramTemp += ' and '; }
          paramTemp += `situacao eq '${this.filter.situacao}'`;
        }

        if (this.filter.codigo){
          if (paramTemp) { paramTemp += ' and '; }
          paramTemp += `id eq ${this.filter.codigo}`;
        }

        this.Listar(paramTemp);
      }
    },
    mounted() {

      const situacaoEnumService = new SituacaoEnumService();
      situacaoEnumService.Listar()
          .then(
              res => {
                  this.situacoes = res.data;
                  this.situacoes.unshift({
                    key: '',
                    value: 'TODOS'
                  });
              },
              err => {
                  this.$swal('Aviso', err.message, 'error');
              }
          );


        this.Atualizar();
    }
}
</script>
<style scoped>

</style>
